const baseConversionsApiPath = 'organizations/:organizationId/conversions';

export const conversionsApiPaths = {
    conversions: baseConversionsApiPath,
    conversionById: `${baseConversionsApiPath}/:conversionId`,
    quotes: `${baseConversionsApiPath}/quotes`,
} as const;
